import CollaborationIcon from './CollaborationIcon'

export default CollaborationIcon
